import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { ShieldAlert, Check } from "lucide-react";
import { api, errMsg, fmtDateTime } from "@/lib/api";
import { PageHeader, Card, Empty } from "@/components/admin/ui";

const KIND: Record<string, string> = { duplicate_session: "Second session blocked", reuse_attempt: "Used code re-entered", rate_limited: "Too many invalid attempts", order_fyi: "FYI: codes ordered & issued", order_issue_failed: "Codes need manual issuing" };

export default function Alerts() {
  const [items, setItems] = useState<any[]>([]);
  const load = () => api.get("/admin/alerts").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);
  const ack = async (id: string) => {
    try {
      await api.post(`/admin/alerts/${id}/ack`);
      load();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <div>
      <PageHeader title="Security alerts" subtitle="Duplicate-session attempts, code reuse and suspicious activity." />
      <Card>
        {items.length ? (
          <ul className="divide-y divide-slate-100" data-testid="alerts-list">
            {items.map((a) => (
              <li key={a.id} className="flex flex-wrap items-center gap-4 px-6 py-4" data-testid={`alert-${a.id}`}>
                <span className={`grid h-10 w-10 shrink-0 place-items-center rounded-xl ${a.acknowledged ? "bg-[#F1F5F9] text-[#94A3B8]" : "bg-[#FEE2E2] text-[#B91C1C]"}`}><ShieldAlert className="h-5 w-5" /></span>
                <div className="min-w-0 flex-1">
                  <p className="font-semibold text-[#1A2536]">{KIND[a.kind] || a.kind}</p>
                  <p className="text-sm text-[#64748B]">{a.message}{a.details?.org && ` · ${a.details.org}`}</p>
                  <p className="text-xs text-[#94A3B8]">{fmtDateTime(a.at)} · IP {a.ip || "—"}</p>
                </div>
                {a.acknowledged ? (
                  <span className="text-xs text-[#94A3B8]">Acknowledged by {a.acknowledged_by}</span>
                ) : (
                  <button className="btn-secondary btn-sm" onClick={() => ack(a.id)} data-testid={`alert-ack-${a.id}`}><Check className="h-4 w-4" /> Acknowledge</button>
                )}
              </li>
            ))}
          </ul>
        ) : <Empty text="No security alerts. All quiet." />}
      </Card>
    </div>
  );
}
